import { setDefaultValues, setToTopDimIds } from '../dimensionUtils'
export function createDefaultPivotConfig(dimensions) {
  let chart = 'bar-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'time' ? 'columns' : type === 'location' ? 'rows' : 'filters'
      if (type === 'time') {
        role = 'filters'
      }
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
    let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
    // repensar seguro...
    let xCandidate = filterDims.find(d => metas[d.id].type !== 'time') || filterDims[0]
    xCandidate.role = 'rows'
    rowsDim.role = 'filters'
    // if (filterDims.length > 0) {
    //   filterDims = filterDims.slice(0, 2)
    //   filterDims.forEach(d => (d.role = 'rows'))
    //   rowsDim.role = 'filters'
    // } else {
    //   let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
    //   rowsDim.role = 'columns'
    //   colsDim.role = 'rows'
    // }
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  //RELLENAMOS ROWS Y COLS
  //Seleccionamos la primera extraDim con mas de un valor
  let extraDims = Object.values(dimensions.dimensionMetas).filter(
    d => d.type !== 'time' && d.type !== 'location'
  )
  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let filtersExtraDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  )
  let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let toRows
  let count = 0
  while (
    count < filtersExtraDims.length &&
    rowsDims.length === 1 &&
    rowsDims[0].values.length === 1
  ) {
    // if (colsDims.length === 1 && colsDims[0].values.length === 1) {
    rowsDims[0].role = 'filters'
    toRows = filtersExtraDims.slice(0, 1) // [filtersExtraDims[0]]
    toRows.forEach(d => (d.role = 'rows'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
    // }
    filtersExtraDims = pivotConfig.dimensions.filter(
      d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
    )
    rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
    count++
  }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}

export function getAvailability() {
  return { enabled: true, enableable: true }
}

export function checkBadData(chartData) {
  return chartData && chartData.slice(1).every(d => !d[1])
}

export default {
  getAvailability,
  createDefaultPivotConfig,
  checkBadData,
  maxChartDims: 1,
  maxRowDims: 1,
  sdvComponent: 'BarChart',
}
